/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_SendingInputs */



/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Chat_Dictate_SendingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_sending = /** @type {((inputs?: Chat_Dictate_SendingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_SendingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Verzenden…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoi…")
	return /** @type {LocalizedString} */ ("Sending…")
});